import React from 'react';
import './profile.scss'
const Profile = () => {
    return (
        <div className="profile-organisms" id="profile">
            <div className="container">
                <div className="profile-section">
                    <img className="rounded-circle" width="200px" height="200px" src="/images/2.jpg" alt="profile-img"/>
                </div>
                <div className="profile-heading-section">
                    <h1 className="text-uppercase">Charly Haholongan Situmorang</h1>
                    <div className="divider-custom-icon">
                        <i className="fas fa-star"></i>
                    </div>
                </div>
                <div className="tag-line">
                    <p>Fresh Graduate - Junior Software Developer</p>
                </div>
            </div>
        </div>
    );
};

export default Profile;